const NAMESPACE = 'C2C';

const SET_C2C_DATA = `${NAMESPACE}/SET_C2C_DATA`;
const SET_SELECTED_TIME_TABLE_DATE = `${NAMESPACE}/SET_SELECTED_TIME_TABLE_DATE`;

export {
    SET_C2C_DATA,
    SET_SELECTED_TIME_TABLE_DATE,
};

export default NAMESPACE;
